<template>
    <div style="">
        <div v-if="searchString.length == 0 && activeCategory.length == 0" style="overflow-y: auto; width:100%;  display: block; padding-right:10px; padding-top:10px; padding-left:10px;">
        <div class="color" style="float:left;"  @click="goBackSpecial()">
            <i class="material-icons" style="font-size: 30px; cursor:pointer;">keyboard_arrow_left</i>
        </div>
        <div v-if="!loaded" style="margin-top:150px;">
            <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
        </div>
            <div class="container" >
                <div class="child" v-for="(data,i) in categories" :key="i" @click="showCategory(data.cat_id,data.category)" >
                       <center> <div class="border">
                            <i class="material-icons" style="color:white;">{{ data.icon}}</i>
                        </div></center>
                    <div style="padding-top:5px; cursor:pointer; width:100%; display:block;" >

                        {{ data.category }}
                    </div>
                </div>  
            </div>
        </div>

        <div class="show-category" v-if="activeCategory.length > 0">      
            <div class="color" style="float:left; padding-right:10px; padding-top:-10px; padding-left:10px;"  @click="activeCategory = []">
                <i class="material-icons" style="font-size: 30px;  cursor:pointer;">keyboard_arrow_left</i>
            </div>      
            <div class="content-category" >
                <h3 style="margin-top:15px; margin-right:42px;">{{ categoryName }}</h3><br>
                <v-expansion-panels>
                    <v-expansion-panel
                    v-for="(data,i) in activeCategory" :key="i"
                    >
                    <v-expansion-panel-header>
                        {{data.question}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="text-left">
                        <span v-html="data.answer"></span>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>


            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            searchString: '',
            categories: [],
            activeCategory: [],
            q: [],
            a: [],
            categoryName: '',
            loaded: false,
        }
    },
    mounted() {
        this.$store.dispatch("getCat").then(data => {
            this.categories = data;
            this.loaded = true;
        })
    },
    methods: {
        goBackSpecial() {
            this.$store.dispatch("goBack");
        },
        showCategory(id,name) {
            this.categoryName = name;
            this.$store.dispatch("getCatFromName",id).then(data => {
                this.activeCategory = data;
            });  
        }
    }
}
</script>


<style lang="scss" scoped>
$primary: var(--primaryColor);
.container {
  width:100%;
  display: flex;
  flex-wrap:wrap;
  justify-content: center;
 
}
.child {
    
    flex: 50%;
    width:80px;
    margin-bottom:20px;
    height:80px;
    justify-content: center;
    flex-grow: 0;
    
}
.child:hover {
    flex: 50%;
    width:80px;
    margin-bottom:20px;
    height:80px;
    justify-content: center;
    flex-grow: 0;
    background-color:$primary;
    color:white;
    border-radius: 3px;
}
.border {
    background-color:$primary;
    width:50px;
    padding:13px;
    height:50px;
    border-radius:50%;
    justify-content: center;
    -webkit-transition: -webkit-transform .8s ease-in-out;
    transition:         transform .8s ease-in-out;
}
.border:hover {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
    cursor:pointer;
}
</style>